<template>
	<div id="leading-enterprises">
		<headerbar :curindex="1"  v-title :data-title="userdata.cityText+'本地重点企业'"></headerbar> 
		<div class="pagecontent centerpage">   
			<div class="whitebox" >
				<!-- <div class="enterparise_guide">
					<div class="w95mg">  
					<div class="s_screen_choose">
						<span class="span-screen">{{notionname}}</span>
					</div> 
					<p class="fr">产业大脑为您找到<span class="searchnum">{{total}}</span>条匹配的{{typefont}}</p>
					</div>
				</div> -->
				<div class="enterprise_list_box"  v-show="enterpristlist.length!=0"> 
				<!-- 龙头企业 -->
				<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
					<tr><th>企业名称</th><th>所属产业</th><th>画像标签</th><th>地区</th><th>投资数</th><th>员工人数</th></tr> 
					<tr v-for="list in enterpristlist">
						<td class="title"  @click="detailrouterto('/enterprises',list.stockCode,2)" >{{list.title}}</td>
						<td class="conpanytags hastag">
							<span class="span-tag" v-for="item in list.notionlist"  @click="tagrouter('/enterpriseTag',2,'notion',item.id,item.name)">{{item.name}}</span> 
						</td>
						<td class="conpanytags hastag"> 
							<span class="span-tag" v-for="item in list.taglist" @click="tagrouter('/enterpriseTag',2,'tag',item.id,item.name)">{{item.name}}</span> 
						</td>
						<td>{{list.area}}</td>     
						<td v-html="list.invest == 50?'50+':list.invest"></td>  
						<td>{{list.insurePerson}}</td>  
					</tr>
				</table> 
				</div>
				<div class="centerpage1 company_pagelist" v-show="totalPage>1">
					<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total" 	v-bind:max-page="maxPage"  v-on:pagehandler="pageHandler">
					</zpagenav>
				</div>
			</div>  
			</div>
		<footerbar></footerbar>
	</div>
</template> 
<script>  
// import {PCC} from "../../assets/js/city.js";
import $ from "jquery";
	export default {
		name: 'localKeyEnterprises',
		data() {
			return {
				msg: "标签筛选页",    
				page: 1,  //显示的是哪一页
				pagetype:2,
				haspage:true,//是否还有下一页
				pageSize: 10, //每一页显示的数据条数
				total: 0, //记录总数
				totalPage:1,
				maxPage:10,  //最大页数  
			 enterpristlist:[],
				num:1,
				testtoken:"-d8d2de4bc22ab997e946f42f9d49b79b", 
				notionname:"标签",
				typefont:'龙头企业'
			}
		},
		beforeCreate() {
			this.bus.$emit('loading', false);
		},
		created() {  
				this.$nextTick(() => {
				        // 禁用右键
				        document.oncontextmenu = new Function("event.returnValue=false");
				        // 禁用选择
				        document.onselectstart = new Function("event.returnValue=false");
				      }); 
		 var _this=this;  
			this.userdata = this.getuseriformation();
			this.tagid=this.$route.query.id;
			this.pagetype=2;
			this.key=this.$route.query.key;
			this.notionname=this.$route.query.keyword;
			if(this.pagetype == 2){this.typefont = '龙头企业'};
			if(this.pagetype == 3){this.typefont = '新兴企业'};
			if(this.pagetype == 5){this.typefont = '投资机构'};
			
			
		},
		mounted() { 
			var _this = this;
   this.pageHandler(1);  
		},
		
		methods: {
		detailrouterto(path,id,type){
			let routeUrl = this.$router.resolve({
					path: path,query: {type:type,id:id}
			});
			window.open(routeUrl.href, '_blank');  
		}, 
			pageHandler: function (page) { 
				this.ajaxsearchcompany(page); 
			}, 
			
			ajaxsearchcompany(pages){
			this.bus.$emit('loading',true); 
			var tagjson='&city='+this.userdata.city; 
			var ajaxurl=ajaxurl=this.$api.cyl.enterprise.list()+'?type=1'+tagjson+'&page='+pages,pagestype=this.pagetype-1;
			var _this=this;   
			this.$axios.get(ajaxurl,{headers:{AuthToken:this.userdata.token}}).then(function(res){
				// console.log(res.data)  
				if(res.data.success){  
				 console.log(res.data);
					_this.enterpristlist=res.data.list;
					
				if(pagestype == 1 || pagestype == 2){
					//大小企业
					for(var i=0;i<res.data.list.length;i++){
						_this.enterpristlist[i].taglist=_this.taglistfun(_this.enterpristlist[i].tag,_this.enterpristlist[i].tagCode);
						_this.enterpristlist[i].notionlist=_this.taglistfun(_this.enterpristlist[i].notion,_this.enterpristlist[i].notionCode);  
						//创新企业专属
						if(_this.pagestype==2  && _this.enterpristlist[i].financingRound == null){
							_this.enterpristlist[i].financingRound=[];
						} 
					}  
				}else if(_this.pagetype == 5){
					//机构列表
					for(var i=0;i<res.data.list.length;i++){
						_this.enterpristlist[i].notionlist=_this.taglistfun(_this.enterpristlist[i].notion,_this.enterpristlist[i].notionCode);  
					}  
				} 
				_this.bus.$emit('loading',false); 
				_this.totalPage=res.data.totalPage;
				_this.pageSize=res.data.pageSize;  
				_this.total=res.data.totalRecord; 
				_this.haspage=res.data.list.length  == res.data.pageSize;  
				}else{ 
					
				} 
			})  
			}
		},
	}
</script>

<style type="text/css" scoped="scoped">
	@import "../../assets/css/zpageNav.css";
</style> 
